$('nav .navbar-nav').on('click', '.dropdown-toggle', function (el) {
    $('nav .navbar-nav').find('.dropdown-menu').css('display', '');
    if ($(el).siblings('.dropdown-menu').css('display') === 'block') {
        $(el).siblings('.dropdown-menu').css('display', '');
    } else {
        $(el).siblings('.dropdown-menu').css('display', 'block');
    }
});
